import { IconButton, Stack, Tooltip } from '@mui/material'

import InstagramIcon from '@mui/icons-material/Instagram'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'

export const SocialMediaBar = () => {
  // Custom TikTok Icon Component
  const TikTokIcon = () => (
    <svg
  width="1em"
  height="1em"
  viewBox="0 0 24 24"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M12.53 2h3.45a8.16 8.16 0 0 0 4.77 1.52v3.4a4.85 4.85 0 0 1-4.77-4.25v13.04a6.34 6.34 0 1 1-6.34-6.34c.32 0 .63.03.94.08V13a2.89 2.89 0 1 0 1.95 2.74V2z"/>
</svg>

  )

  const socialLinks = [
    { 
      icon: InstagramIcon, 
      label: 'Instagram', 
      url: 'https://www.instagram.com/nexocartperfumes?igsh=NzhqaHhjcDFkNXZn',
      color: '#E4405F'
    },
    { 
      icon: TikTokIcon, 
      label: 'TikTok', 
      url: 'https://www.tiktok.com/@nexocart.perfumes?_r=1&_t=ZS-96jK4KKQYde',
      color: '#000000'
    },
    { 
      icon: WhatsAppIcon, 
      label: 'WhatsApp Channel', 
      url: 'https://whatsapp.com/channel/0029VbCWGUrFCCoMptsNfm26',
      color: '#25D366'
    },
    { 
      icon: LinkedInIcon, 
      label: 'LinkedIn', 
      url: 'https://www.linkedin.com/in/𝙉𝙚𝙭𝙤𝙘𝙖𝙧𝙩-𝙋𝙚𝙧𝙛𝙪𝙢𝙚𝙨-157031412',
      color: '#0077B5'
    }
  ]

  return (
    <Stack 
      direction="row" 
      spacing={1} 
      sx={{ 
        justifyContent: 'center',
        alignItems: 'center',
        py: 1,
        bgcolor: '#f5f5f5',
        borderBottom: '1px solid #e0e0e0',
        flexWrap: 'wrap'
      }}
    >
      {socialLinks.map((social, idx) => {
        const Icon = social.icon
        return (
          <Tooltip key={idx} title={social.label}>
            <IconButton
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: social.color || '#333',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.2) translateY(-2px)',
                  filter: 'brightness(1.2)',
                  boxShadow: `0 4px 12px ${social.color}40`
                }
              }}
            >
              <Icon fontSize="small" />
            </IconButton>
          </Tooltip>
        )
      })}
    </Stack>
  )
}
